var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    on: {
      "contextmenu": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "cover",
    style: {
      width: _vm.pageWidth,
      height: _vm.pageHeight
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('div', {
    staticClass: "container",
    style: {
      top: _vm.menuY + 'px',
      left: _vm.menuX + 'px'
    }
  }, _vm._l(_vm.cellList, function (cell, idx) {
    return _c('div', {
      key: 'menuItem' + idx,
      class: idx == 0 ? 'munucell borderNone' : 'munucell',
      on: {
        "click": function ($event) {
          return _vm.cellClick(idx);
        }
      }
    }, [_vm._v(" " + _vm._s(cell.label) + " ")]);
  }), 0)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };